// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries -- TODO(strict-boundaries): legacy violation, remove after refactor
import { text } from '@neptune/shared/venus-ui';

export type OverrideIndicators = {
  showMainIndicator: boolean;
  mainIndicatorColor: text.Color;
  showSectionOverrideBadge: boolean;
  settingOverrideInSectionsCount: number;
  showModeConflictIndicator: boolean;
  showColumnCountsConflictIndicator: boolean;
};

export const overrideIndicatorsDefaults: OverrideIndicators = {
  showMainIndicator: false,
  mainIndicatorColor: 'info',
  showSectionOverrideBadge: false,
  settingOverrideInSectionsCount: 0,
  showModeConflictIndicator: false,
  showColumnCountsConflictIndicator: false,
};
